<div
    class="input-field"
    #inputField
    [class.invalid]="dateRangeInputInvalid"
    [class.pending]="!dateRangeInputInvalid && dateRangeInputPending"
>
    <input
        [attr.aria-labelledby]="ariaLabel"
        name="displayDate"
        [(ngModel)]="dateRangeInput"
        pInputText
        [placeholder]="placeholderText"
        (focus)="onFocus()"
        (keyup)="onKeyUp()"
        oninput="this.value = this.value.replace(/[^0-9.-\s]/g, '')"
    />
    @if (!dateRangeInput) {
        <button (click)="toggleCalendar($event, inputField)">
            <img src="assets/icons/input-calendar.svg" alt="Kalender öffnen" />
        </button>
    } @else {
        <button (click)="clearDateRange()">
            <i class="pi pi-times" aria-label="Datumseingabe löschen"></i>
        </button>
    }
</div>
<p-popover
    #calendarPanel
    [dismissable]="true"
    (onShow)="showCalendar()"
    (onHide)="calendarHidden = true"
    styleClass="date-range-input-overlay-panel"
>
    <ng-template #content>
        <p-datePicker [(ngModel)]="calendarValue" [inline]="true" selectionMode="range" [maxDate]="maximumDate">
        </p-datePicker>
    </ng-template>
</p-popover>
